/* COSYFUR — couche kawaii : Yumi anime la visite guidée, les avis et la barre sticky */
(() => {
  'use strict';
  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- machine à écrire (indépendante par bulle, plusieurs en parallèle) ---------- */
  function typeInto(el, full, speed) {
    const caret = document.createElement('span');
    caret.className = 'caret';
    el.textContent = '';
    el.appendChild(caret);
    let i = 0;
    (function tick() {
      if (i < full.length) { caret.before(full[i++]); setTimeout(tick, speed); }
      else caret.remove();
    })();
  }

  /* ---------- visite guidée : chaque bulle s'écrit quand elle arrive à l'écran ---------- */
  const bullesVisite = [...document.querySelectorAll('.vg-dit .bd-texte')];
  if (bullesVisite.length) {
    bullesVisite.forEach((el) => {
      el.dataset.full = el.textContent;
      if (!REDUCED) {
        el.style.minHeight = el.offsetHeight + 'px';   // réserve la place → aucun saut de mise en page
        el.textContent = '';
      }
    });
    if (!REDUCED && 'IntersectionObserver' in window) {
      const vio = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            vio.unobserve(e.target);
            typeInto(e.target, e.target.dataset.full || '', 16);
          }
        });
      }, { threshold: 0.75 });
      bullesVisite.forEach((el) => vio.observe(el));
    }
  }

  /* ---------- avis : flèches du rail ---------- */
  const rail = document.getElementById('avisRail');
  if (rail) {
    const pas = () => Math.min(rail.clientWidth * 0.85, 380);
    document.querySelectorAll('[data-avis-nav]').forEach((b) => {
      b.addEventListener('click', () => {
        rail.scrollBy({ left: b.dataset.avisNav === 'next' ? pas() : -pas(), behavior: REDUCED ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- barre sticky mobile ---------- */
  const bar = document.getElementById('stickyCta');
  if (bar) {
    const fin = document.querySelector('.club, .site-footer');
    let cache = false;
    if (fin && 'IntersectionObserver' in window) {
      new IntersectionObserver((es) => {
        cache = es.some((e) => e.isIntersecting);
        maj();
      }).observe(fin);
    }
    function maj() {
      bar.classList.toggle('visible', window.scrollY > 560 && !cache);
    }
    addEventListener('scroll', maj, { passive: true });
    maj();

    // page produit : le bouton de la barre soumet le vrai formulaire
    const submitCible = bar.dataset.form && document.querySelector(bar.dataset.form);
    const btn = bar.querySelector('button[data-atc]');
    if (btn && submitCible) {
      btn.addEventListener('click', () => {
        if (submitCible.requestSubmit) submitCible.requestSubmit();
        else submitCible.submit();
      });
    }
  }
})();
